import { pgEnumFromObject } from "../../../functions/pgEnumFromObject";
import { permissionOrder } from "@shared/utils/src/core/functions/permissionOrder";

/**
 * @group Enums
@summary
<blockquote>PostgreSQL enum for permission verbs</blockquote>
 * @internal
 */
export const permissionVerbEnum = pgEnumFromObject('permission_verb', 
    Object.fromEntries(permissionOrder.map(verb => [verb, verb]))
  ); 